/* @flow */

import { callApiEndpoint } from './index';
import utils from './utils';

import type { ProductionType, FindProductionTypeParams } from 'types';

const find = async (params: ?FindProductionTypeParams): Promise<ProductionType[]> => {
  const { broadcastTypeId, usageTypeId } = params || { broadcastTypeId: 0, usageTypeId: 0 };

  let pathUrl = (broadcastTypeId || 2) + '/' + (usageTypeId || 3);

  const response = await callApiEndpoint(
    'tipologieproduzione/' + pathUrl + '/findByTipologiaEmissioneAndTipologiaUtilizzo',
    { params: {} }
  );

  return response.map(utils.toProductionType);
};

export default {
  find,
};
